import { render, staticRenderFns } from "./figment-research.vue?vue&type=template&id=751d0254&"
import script from "./figment-research.vue?vue&type=script&lang=js&"
export * from "./figment-research.vue?vue&type=script&lang=js&"
import style0 from "./figment-research.vue?vue&type=style&index=0&id=751d0254&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports